import { SensorDtoSchema } from "@station/data/dto/sensor.dto";
import * as z from "zod";

const YAxesDtoSchema = z
    .object({
        id: z.number(),
        label: z.string().trim(),
        variable_ids: z.array(z.number()),
    })
    .readonly();

export const SensorGroupDtoSchema = z
    .object({
        id: z.number(),
        name: z.string().trim(),
        public_name: z.string().trim().nullable(),
        variables: z.array(SensorDtoSchema),
        y_axes: z.array(YAxesDtoSchema),
    })
    .readonly();
export type SensorGroupDto = z.output<typeof SensorGroupDtoSchema>;

export const SensorGroupsDtoSchema = z.array(SensorGroupDtoSchema).readonly();
export type SensorGroupsDto = z.output<typeof SensorGroupsDtoSchema>;
